export default __webpack_public_path__ + "static/team-Brian-1e3e584bd69681f24ebe41b39da147cf.png";